module.exports = __webpack_public_path__ + "static/media/logo.ae7b760d.svg";